module.exports = __webpack_public_path__ + "static/26_PLATOS-ARG-ASADO-D.4462c7ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/26_PLATOS-ARG-ASADO-D.png
// module id = 673
// module chunks = 35783957827783